import { Avatar, IconButton } from "@mui/material";
import React, { useState } from "react";
import { useTranslation } from "react-i18next";

import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { logout } from "../redux/actions/authActions";
import Dropdown from "./Dropdown";
import { MoreVert } from "@mui/icons-material";

const Header = () => {
  const [element, setElement] = useState(null);
  const { user } = useSelector((state) => state.Auth);
  // const { profile } = useSelector((state) => state.ProfileDetails);
  const dispatch = useDispatch();

  const { i18n } = useTranslation();
  const open = Boolean(element);
  return (
    <>
      <header className=" flex justify-between items-center  p-2 px-3">
        <select
          className="bg-transparent "
          defaultValue={i18n.language}
          onChange={(e) => i18n.changeLanguage(e.target.value)}>
          <option value="en">English</option>
          <option value="ar">عربي</option>
        </select>

        <Link to="/" className="text-2xl md:text-3xl  uppercase text-[#fab8ba]">
          heart<span className="text-black">link</span>
        </Link>

        <div className="flex child:text-center">
          {user.authenticated ? (
            <IconButton
              // src={`http://localhost:5000/${profile.profileImage}`}
              alt="avatar"
              onClick={(e) => setElement(e.currentTarget)}>
              <MoreVert />
            </IconButton>
          ) : (
            <>
              <Link to="/auth/login" className="bg-[#fff4f3] rounded p-2">
                Login
              </Link>
              <Link to="/auth/register" className="bg-[#ffb4b4] rounded p-2 ">
                Register
              </Link>
            </>
          )}
        </div>
      </header>
      <Dropdown open={open} element={element} setElement={setElement} />
    </>
  );
};

export default Header;
